import { render, staticRenderFns } from "./Preview-SearchResult.vue?vue&type=template&id=bdc2ff14&scoped=true&"
import script from "./Preview-SearchResult.vue?vue&type=script&lang=js&"
export * from "./Preview-SearchResult.vue?vue&type=script&lang=js&"
import style0 from "./Preview-SearchResult.vue?vue&type=style&index=0&id=bdc2ff14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc2ff14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItemContent,VListItemSubtitle,VListItemTitle})
